import { Link, useParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Article.scss';
import UserContext from '../store/userContext';
import articleService from '../services/ArticleService';
import SiteService from '../services/SiteService';
import ArticleRenderer from '../components/articleEdit2/ArticleRenderer';
import siteService from "../services/SiteService";

function Article({ article, setArticle }) {
	const userContext = useContext(UserContext);
	const { urlString } = useParams();
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);
	const [isPluss, setIsPluss] = useState(false);
	const [loadedAuthor, setLoadedAuthor] = useState({});
	const [fetchErrorCode, setFetchErrorCode] = useState(undefined);

	if(!article)
		[article, setArticle] = useState(null);

	// Reset the article when the URL changes
	useEffect(() => {
		let isMounted = true;

		async function fetchArticle() {
			try {
				const response = await fetch(`${SiteService.apiPath}/article/urlstring/${urlString}/aggregate`);
				if (!response.ok) {
					setFetchErrorCode(response.status);
					return console.log(response.status);
				}
				const data = await response.json();
				if (isMounted) {
					setArticle(data.articleInfo);
					if (siteService.appName === 'storbatmagasinet'){
						if(data.tags&&data.tags.length>0){
							data.tags = data.tags.map((tag) => {
								if(tag.startsWith('Storbåtmagasinet')) return tag;
							});
						}
					}
					setIsPluss(data.notSubscribed);
					if (data.author) setLoadedAuthor(data.author);
					document.title = data.articleInfo.name;
					setIsLoading(false);
				}
			} catch (error) {
				console.error(error);
			}
		}

		setIsLoading(true);
		setArticle(null); // Clear the previous article state
		fetchArticle();

		return () => {
			isMounted = false;
		};
	}, [urlString]);

	function EditLink() {
		if (userContext.role > 0) {
			return (
				<nav className={'adminModerateLinks'}>
					<Link to={'/admin/artikkel-rediger/' + urlString}>Rediger artikkel</Link>
					<button className={'deleteArticleButton'} onClick={()=>{
						articleService.setRelatedArticles(article._id);
					}}>
						Generer relaterte artikler
					</button>
					<button
						className={'deleteArticleButton'}
						onClick={() =>
							articleService.delete(article._id, (data) => {
								if (data.destination) {
									return navigate(data.destination);
								}
								navigate('/');
							})
						}
					>
						Slett artikkel
					</button>
				</nav>
			);
		}
	}

	if (fetchErrorCode !== undefined) {
		return (
			<div className={'errorContainer'}>
				{fetchErrorCode === 404 && <><h1>Fant ikke artikkelen</h1>
					<h3>Men ikke gi opp! Kanskje den finnes her likevel!</h3>
					<button style={{fontSize:'1.3em'}} className={'button1 centered'} onClick={()=>{
						document.getElementById('searchOpenButton').click();
					}}>Søk etter nøkkelord</button>
				</>}
				{fetchErrorCode === 500 && <h1>Oops.. En feil har oppstått</h1>}
				{fetchErrorCode!==404&&<h2>Feilkode: {fetchErrorCode}</h2>}
				<br/>
				<Link to={'/'}>Til forside</Link>
			</div>
		);
	}

	if (isLoading || !article) {
		return <p className={'centered loading'} style={{marginTop:'100px', padding:'20px'}}>Laster...</p>;
	}

	return (
		<>
			<EditLink />
			<ArticleRenderer article={article} isPluss={isPluss} loadedAuthor={loadedAuthor} />
		</>
	);
}

export default Article;
